import { useFormContext } from 'react-hook-form';
import { useState, useEffect } from 'react';
import { Check, Loader2, ArrowLeft } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { MultiSelect } from '@/components/MultiSelect';
import SelectTagInput from '@/components/SelectTagInput';
import { creatorsService } from '@/services/creators';
import { Creator } from '@/types/creators';

import { BrandFormData, SubmitPhaseProps } from '@/pages/settings/content/brands-sectors/create/shared/types';

export default function Four({ onSubmit, onBack, isSubmitting }: SubmitPhaseProps) {
  const { watch, setValue, formState: { errors } } = useFormContext<BrandFormData>();
  const [creators, setCreators] = useState<Creator[]>([]);
  
  const watchedData = watch();

  useEffect(() => {
    const loadCreators = async () => {
      try {
        const creatorsData = await creatorsService.getAll();
        setCreators(creatorsData.data || []);
      } catch (error) {
        console.error('Error loading creators:', error);
      }
    };

    loadCreators();
  }, []);

  return (
    <div className="space-y-8">
      <div>
        <h2 className="text-2xl font-bold text-gray-900 mb-2">Nova Marca</h2>
        <p className="text-gray-600">Adicione uma nova Marca ao Culture Monitor.</p>
      </div>

      <div className="space-y-6">
        <div>
          <h3 className="text-lg font-semibold text-gray-900 mb-2">Informações Adicionais</h3>
          <p className="text-sm text-gray-600 mb-6">Insira abaixo as informações da Marca.</p>
        </div>

        <div className="space-y-6">
          <div>
            <h4 className="text-base font-semibold text-gray-900 mb-4">Creators de Interesse</h4>
            <MultiSelect
              value={watchedData.creators || []}
              onChange={(ids) => setValue('creators', ids, { shouldValidate: true })}
              items={creators.map((creator) => ({
                id: creator.id,
                name: `${creator.name} (@${creator.handle})`,
              }))}
              placeholder="Selecione o(s) creator(s)"
              loading={creators.length === 0}
            />
            {errors.creators && (
              <p className="text-red-500 text-xs mt-1">{errors.creators.message}</p>
            )}
          </div>


          <div>
            <h4 className="text-base font-semibold text-gray-900 mb-4">Objetivos da Marca</h4>
            
            <SelectTagInput
              value={watchedData.objectives || []}
              onChange={(tags) => setValue('objectives', tags, { shouldValidate: true })}
              placeholder="Defina os itens"
              showSearchIcon={true}
              items={[]}
              loading={false}
              hideButton
            />
            {errors.objectives && (
              <p className="text-red-500 text-xs mt-1">{errors.objectives.message}</p>
            )}
          </div>
        </div>
      </div>

      <div className="flex justify-between">
        {onBack && (
          <Button
            type="button"
            variant="outline"
            onClick={onBack}
            disabled={isSubmitting}
            className="flex items-center gap-2"
          >
            <ArrowLeft className="w-4 h-4" />
            Voltar
          </Button>
        )}
        
        <Button
          type="button"
          onClick={onSubmit}
          disabled={isSubmitting}
          className="bg-gray-800 text-white hover:bg-gray-900 flex items-center gap-2 px-8 py-3"
        >
          {isSubmitting ? (
            <Loader2 className="w-4 h-4 animate-spin" />
          ) : (
            <Check className="w-4 h-4" />
          )}
          {isSubmitting ? 'Cadastrando...' : 'Cadastrar Marca'}
        </Button>
      </div>
    </div>
  );
}